import { FC } from 'react';
import { Tooltip } from '@mui/material';
import { BoltOutlined, Cancel } from '@mui/icons-material';

type TProps = {
  toolTipText: string;
  isRunningIngestion: boolean;
};

const IngestionButtonIcon: FC<TProps> = ({ toolTipText, isRunningIngestion }) => {
  return (
    <Tooltip title={toolTipText} placement="bottom-end">
      <span className="tw:flex tw:flex-row tw:justify-center tw:items-center tw:gap-1">
        {isRunningIngestion ? (
          <Cancel style={{ width: 16, height: 16 }} />
        ) : (
          <BoltOutlined style={{ width: 16, height: 16 }} />
        )}
      </span>
    </Tooltip>
  );
};

export default IngestionButtonIcon;
